if (!customElements.get('product-feature-image')) {
	class ProductFeatureImage extends HTMLElement {
		// Each group toggles independently so the title and image can have
		// different element counts (e.g. variants sharing one image).
		static GROUPS = [
			{ selector: '.product-feature-image__title', active: 'product-feature-image__title--active' },
			{ selector: '.product-feature-image__image', active: 'product-feature-image__image--active' },
		];
		connectedCallback() {
			this.groups = ProductFeatureImage.GROUPS.map((group) => ({
				active: group.active,
				items: this.querySelectorAll(group.selector),
				current: this.querySelector(`.${group.active}`),
			}));
			const total = this.groups.reduce((sum, group) => sum + group.items.length, 0);
			if (total < 2) {
				return;
			}
			this.boundVariantChange = (event) => this.handleVariantChange(event.detail.id);
			document.addEventListener('variant_change', this.boundVariantChange);
		}
		disconnectedCallback() {
			if (this.boundVariantChange) {
				document.removeEventListener('variant_change', this.boundVariantChange);
			}
		}
		handleVariantChange(variant_id) {
			for (const group of this.groups) {
				for (const item of group.items) {
					if (item.dataset.variant != variant_id) {
						continue;
					}
					if (item === group.current) {
						break;
					}
					if (group.current) {
						group.current.classList.remove(group.active);
						group.current.setAttribute('aria-hidden', 'true');
					}
					group.current = item;
					group.current.classList.add(group.active);
					group.current.setAttribute('aria-hidden', 'false');
					break;
				}
			}
		}
	}
	customElements.define('product-feature-image', ProductFeatureImage);
}
